var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomebanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 52 52",
    enableBackground: "new 0 0 52 52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.6,29.2h-8c-1.3,0-2.4-1.1-2.4-2.4v-1.6 c0-1.3,1.1-2.4,2.4-2.4h8c1.3,0,2.4,1.1,2.4,2.4v1.6C50,28.1,48.9,29.2,47.6,29.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30,29.2h-8c-1.3,0-2.4-1.1-2.4-2.4v-1.6 c0-1.3,1.1-2.4,2.4-2.4h8c1.3,0,2.4,1.1,2.4,2.4v1.6C32.4,28.1,31.3,29.2,30,29.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4,29.2h-8C3,29.2,2,28.1,2,26.8v-1.6 c0-1.3,1.1-2.4,2.4-2.4h8c1.3,0,2.4,1.1,2.4,2.4v1.6C14.8,28.1,13.7,29.2,12.4,29.2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6,34H8.4c-1.8,0-3.2,1.4-3.2,3.2v8c0,1.8,1.4,3.2,3.2,3.2h35.2 c1.8,0,3.2-1.4,3.2-3.2v-8C46.8,35.4,45.3,34,43.6,34z M42,42.8c0,0.4-0.4,0.8-0.8,0.8H10.8c-0.4,0-0.8-0.4-0.8-0.8v-3.2 c0-0.4,0.4-0.8,0.8-0.8h30.4c0.4,0,0.8,0.4,0.8,0.8V42.8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6,3.6H8.4C6.6,3.6,5.2,5,5.2,6.8v8c0,1.8,1.4,3.2,3.2,3.2h35.2 c1.8,0,3.2-1.4,3.2-3.2v-8C46.8,5,45.3,3.6,43.6,3.6z M42,12.4c0,0.4-0.4,0.8-0.8,0.8H10.8c-0.4,0-0.8-0.4-0.8-0.8V9.2 c0-0.4,0.4-0.8,0.8-0.8h30.4c0.4,0,0.8,0.4,0.8,0.8V12.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomebanner);
export default __webpack_public_path__ + "static/media/homebanner.7f340cafc98dda8c5192181e363d6723.svg";
export { ForwardRef as ReactComponent };